import { AbstractCollisionHandler } from "../../componentLibrary/AbstractCollisionHandler.js";
export class DeliveryCollisionHandler extends AbstractCollisionHandler {
    constructor() {
        super();
    }
    handleCollision(oth, boundingBox) {
    }
}
